/* eslint-disable react/prop-types */
import React from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Chip,
  Button,
} from "@material-ui/core";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import moment from "moment";

const InfoRow = ({ label, value }) => (
  <Grid container style={{ marginBottom: 10 }}>
    <Grid item xs={4} sm={3}>
      <Typography style={{ fontWeight: 600, fontSize: 14, color: "#555" }}>{label}</Typography>
    </Grid>
    <Grid item xs={8} sm={9}>
      <Typography style={{ fontSize: 14 }}>{value || "N/A"}</Typography>
    </Grid>
  </Grid>
);

const StatusChip = ({ status }) => {
  const colorMap = {
    AVAILABLE: { bg: "#e8f5e9", color: "#2e7d32" },
    INACTIVE:  { bg: "#f5f5f5", color: "#616161" },
    SOLD:      { bg: "#e3f2fd", color: "#1565c0" },
    RENTED:    { bg: "#fff3e0", color: "#e65100" },
  };
  const style = colorMap[status] || { bg: "#f5f5f5", color: "#333" };
  return (
    <Chip
      label={status || "N/A"}
      size="small"
      style={{ background: style.bg, color: style.color, fontWeight: 600 }}
    />
  );
};

const normalizeMedia = (val) => {
  if (!val) return [];
  if (Array.isArray(val)) return val.filter(Boolean);
  if (typeof val === "object" && val.url) return [val];
  return [];
};

const ViewMarketplace = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { item, userId } = state || {};

  console.log("[ViewMarketplace] item:", item);

  const imageItems = normalizeMedia(item?.images);

  if (!item) {
    return (
      <Container maxWidth={false} disableGutters style={{ margin: "0 2%" }}>
        <Typography>No marketplace item data found.</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth={false} disableGutters style={{ margin: "0 2%", minHeight: "70vh" }}>
      {/* Breadcrumb */}
      <Typography
        style={{ fontWeight: "bold", display: "flex", alignItems: "center", flexWrap: "wrap", marginBottom: 16 }}
      >
        <Link to="/admin/user" style={{ color: "black", textDecoration: "none", marginRight: 4 }}>
          Users
        </Link>
        &gt;
        <span
          style={{ cursor: "pointer", marginLeft: 4, marginRight: 4 }}
          onClick={() => navigate("/admin/user/view-user", { state: { id: userId } })}
        >
          View User
        </span>
        &gt;
        <span style={{ fontWeight: "bold", marginLeft: 4 }}>Marketplace Detail</span>
      </Typography>

      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate(-1)}
        style={{ marginBottom: 16 }}
        variant="outlined"
        size="small"
      >
        Back
      </Button>

      {/* Detail Card */}
      <Box
        style={{
          background: "#fff",
          borderRadius: 8,
          padding: 24,
          boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
        }}
      >
        {/* Title row */}
        <Box style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
          <Typography variant="h6" style={{ fontWeight: 700 }}>
            {item.productName || "Marketplace Item"}
          </Typography>
          <StatusChip status={item.status} />
          {item.type && (
            <Chip label={item.type} size="small" variant="outlined" />
          )}
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <InfoRow label="Product Name" value={item.productName} />
            <InfoRow label="Brand" value={item.brand} />
            <InfoRow label="Series" value={item.series} />
            <InfoRow label="Model" value={item.productModel} />
            <InfoRow label="Product Type" value={item.productType} />
            <InfoRow label="Custom Product Name" value={item.customProductName} />
            <InfoRow label="Type" value={item.type} />
            <InfoRow label="Category" value={item.category} />
            <InfoRow label="Condition" value={item.condition} />
            <InfoRow label="Seller Type" value={item.sellerType} />
            <InfoRow label="Status" value={item.status} />
            <InfoRow
              label="Price"
              value={item.price !== null && item.price !== undefined ? `$${item.price}` : null}
            />
            <InfoRow label="Location" value={item.location?.place || [item.city, item.state].filter(Boolean).join(", ")} />
          </Grid>
          <Grid item xs={12} md={6}>
            {item.type === "RENT" && (
              <>
                <InfoRow
                  label="Rent Start"
                  value={item.rentStartDate ? moment(item.rentStartDate).format("DD/MM/YYYY") : null}
                />
                <InfoRow
                  label="Rent End"
                  value={item.rentEndDate ? moment(item.rentEndDate).format("DD/MM/YYYY") : null}
                />
                <InfoRow label="Security Deposit" value={item.securityDeposit} />
                <InfoRow label="Rental Terms" value={item.rentalTerms} />
                <InfoRow label="Pickup/Delivery" value={item.pickupDeliveryOption} />
              </>
            )}
            <InfoRow label="Purchase Year" value={item.purchaseYear} />
            <InfoRow label="Bill Available" value={item.billAvailable === null || item.billAvailable === undefined ? null : (item.billAvailable ? "Yes" : "No")} />
            <InfoRow label="Warranty Available" value={item.warrantyAvailable === null || item.warrantyAvailable === undefined ? null : (item.warrantyAvailable ? "Yes" : "No")} />
            <InfoRow label="Available Quantity" value={item.availableQuantity} />
            <InfoRow label="Reason For Selling" value={item.reasonForSelling} />
            <InfoRow
              label="Included Accessories"
              value={Array.isArray(item.includedAccessories) && item.includedAccessories.length ? item.includedAccessories.join(", ") : null}
            />
            <InfoRow
              label="Created At"
              value={item.createdAt ? moment(item.createdAt).format("DD/MM/YYYY HH:mm") : null}
            />
            <InfoRow
              label="Updated At"
              value={item.updatedAt ? moment(item.updatedAt).format("DD/MM/YYYY HH:mm") : null}
            />
          </Grid>
        </Grid>

        {/* Description */}
        <Box style={{ marginTop: 16 }}>
          <Typography style={{ fontWeight: 600, fontSize: 14, color: "#555", marginBottom: 4 }}>
            Description
          </Typography>
          <Typography style={{ fontSize: 14 }}>
            {item.description || "N/A"}
          </Typography>
        </Box>

        {/* Images */}
        {imageItems.length > 0 && (
          <Box style={{ marginTop: 24 }}>
            <Typography style={{ fontWeight: 600, fontSize: 14, color: "#555", marginBottom: 8 }}>
              Images ({imageItems.length})
            </Typography>
            <Grid container spacing={2}>
              {imageItems.map((img, i) => {
                const type = (img.mediaType || "").toLowerCase();
                return (
                  <Grid item key={i} xs={6} sm={4} md={3}>
                    {type === "video" ? (
                      <Box style={{ borderRadius: 8, overflow: "hidden", background: "#000" }}>
                        <video
                          src={img.url}
                          controls
                          style={{ width: "100%", height: 140, objectFit: "cover", display: "block" }}
                        />
                        <Typography variant="caption" style={{ display: "block", padding: "4px 6px", color: "#ccc", background: "#111", fontSize: 11 }}>
                          {img.name || `img-${i}`}
                        </Typography>
                      </Box>
                    ) : (
                      <img
                        src={img.url}
                        alt={img.name || `img-${i}`}
                        style={{
                          width: "100%",
                          height: 140,
                          objectFit: "cover",
                          borderRadius: 8,
                          border: "1px solid #eee",
                          display: "block",
                        }}
                      />
                    )}
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default ViewMarketplace;
